var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('RelatorioLpsNaoVisitaList',{directives:[{name:"show",rawName:"v-show",value:(!_vm.rotaAninhada),expression:"!rotaAninhada"}],attrs:{"reloadData":_vm.reloadData}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }